import Favicon from "../src/assets/images/favicon.ico"
import Nestlypay1 from "../src/assets/images/nestlypay2.png"
import P2PFi from "../src/assets/images/p2pfi.png"
import Groomlog from "../src/assets/images/groomlog.png"
import Credfare from "../src/assets/images/credfare.png"
import NidFul from "../src/assets/images/nidful.png"
import IoTRoom from "../src/assets/images/iotroom.png"
import Buckinghammall from "../src/assets/images/buckinghammall.png"
import Resume from "../src/files/Victor_Emmanuel_Resume.pdf"



const logotext = "VICTOR EDIDIONG";
const meta = {
    headerTitle: "iamEdDy - Blockchain Developer",
    headerImg: Favicon,
    title: "Victor EdDy",
    description: "I’m Victor EdDy, blockchain, full stack developer and mechatronics engineer.",
};

const introdata = {
    title: "I’m Victor Eddy",
    animated: {
        first: "I see.",
        second: "I code.",
        third: "I fix.",
    },
    description: "Here, its just me, dedicating my life to finding the easiest routes to programmable solutions",
    your_img_url: "https://images.unsplash.com/photo-1514790193030-c89d266d5a9d",
};

const dataabout = {
    title: "A bit about my self",
    aboutme: "Here again, its me still finding easier solutions to problems. I love to show y'all how we can work together in achieving this, if you would love to join me, please contact me. Asides that, I am just being me, motivated by me to solve everyone's problems.",
};
const worktimeline = [
    {
        jobtitle: "Lead Software Developer",
        where: "Nsisong Labs",
        date: "2022-2025",
    },
    {
        jobtitle: "IoT & Robotics Engineer",
        where: "Hamzatronics Technologies",
        date: "2025",
    },
    {
        jobtitle: "Lead Front-end Engineer",
        where: "Groomlog LTD",
        date: "2023-2024",
    },
    {
        jobtitle: "Lead Software Engineer",
        where: "P2PFi Limited",
        date: "2021-2023",
    },
    {
        jobtitle: "Earlier Development Experiences",
        where: "Codeliners, Cleanr, Contract Roles (Remote)",
        date: "2017",
    },
];

const skills = [
    {
        type: "Languages",
        text: "React, Python, Typescript, Solidity, FLutter",
        value: 100,
    },
    {
        type: "Backend",
        text: "FastAPI, NodeJS, Rest APIs, Laravel",
        value: 100,
    },
    {
        type: "IoT and Robotics",
        text: "C++ & Arduino Code, Matlab, ROS 2",
        value: 100,
    },
    {
        type: "Databases",
        text: "PostgreSQL, MySQL, Redis, MongDB",
        value: 100,
    },
    {
        type: "Infra",
        text: "Docker, Ngix, Linux, Github Actions, Git, CI/CD, AWS, GCP",
        value: 100,
    },
];

const services = [    
    {
        title: "Blockchain Development",
        description: "Its always been a pleasure doing outrageous things to solve complex problems, Developing smart contracts and blockchain solutions? Touché.",
    },
    {
        title: "Web Design & Development",
        description: "What do you know about this, well, all I know is users on any web platform i build don't leave the same way.",
    },
    {
        title: "UI & UX Design",
        description: "Easily, I bring in the best web interactions and experience in my designs and with extreme 3D integrations.",
    },
    {
        title: "IoT and Robotics",
        description: "I know this is crazy yeah, but i build very intersting robots and embedded systems. Not convinced? Text me.",
    },
    {
        title: "Mobile Apps",
        description: "I enjoy making apps to help people easily access solutions to very complex tasks with mobile devices.",
    },
    {
        title: "Automations",
        description: "Noone wants to manually perform tasks anymore. Good thing I always build solutions that fix that.",
    },

];

const cv = [{
    name: "Resume.pdf",
    file: Resume,
    updated: "Updated June 2026"
}]; 

const dataportfolio = [{
        img: P2PFi,
        desctiption: "P2P Finance Limited.",
        link: "https://p2pfi.co",
    },
    {
        img: Nestlypay1,
        desctiption: "NestlyPay Limited.",
        link: "https://nestlypay.netlify.app",
    },
    {
        img: Groomlog,
        desctiption: "Groomlog Limited.",
        link: "https://groomlog.net",
    },
    {
        img: Buckinghammall,
        desctiption: "Buckingham Mall.",
        link: "https://buckinghammall.live",
    },
    {
        img: IoTRoom,
        desctiption: "IoT Room",
        link: "https://iotroom.eddyspace.com",
    },
    {
        img: NidFul,
        desctiption: "Nidful App",
        link: "#",
    },
    {
        img: Credfare,
        desctiption: "CredFare",
        link: "#",
    },
];

const contactConfig = {
    YOUR_EMAIL: "victor@eddyspace.com",
    YOUR_FONE: "+234 (913)504-2728",
    description: "If you'd love to join me in creating easier solutions to the most complex problems, hit me up. Any other enquiries are welcomed too.",
//    YOUR_SERVICE_ID: "service_4cx9ctq",
//    YOUR_TEMPLATE_ID: "template_m9idoip",
//    YOUR_USER_ID: "Yq2yKflqPlQKeSJ2L",
    YOUR_SERVICE_ID: "service_6tee2m8",
    YOUR_TEMPLATE_ID: "template_0x8xcrn",
    YOUR_USER_ID: "bpAfqdzNaaOyP1Q4v",
};

const socialprofils = {
    github: "https://github.com/iamEdDy",
    linkedin: "https://linkedin.com/in/victoredidiong",
    twitter: "https://twitter.com/eddyspace_",
};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    cv,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
